import "./FactoryLine.scss";
import { useTranslation } from "react-i18next";
import CustomDonutChart from "../DonutChart/CustomDonutChart";

const FactoryLine = ({ data, getLineData }) => {
  const { t } = useTranslation();

  const ValidateColor = (processValue) => {
    let status;
    if (processValue >= 90) {
      // Green
      status = "#3cc480";
    } else if (processValue > 60 && processValue < 90) {
      // Yellow
      status = "#ffc60a";
    } else if (processValue <= 60) {
      // Red
      status = "#ff5544";
    }
    return status;
  };

  const GenerateStatisticsData = (data) => {
    return (
      <div className="factory-overview-wrapper highlight-border">
        <div className="factory-overview-header">
          {t(data.name)} {t("LT_overview")}
        </div>
        <div className="factory-overview-body">
          <div className="row factory-overview-body-indent">
            {data.statistics &&
              data.statistics.map((item, index) => {
                let processValue = parseFloat(item.value.toFixed(1));
                let statusColor = ValidateColor(processValue);

                return (
                  <div key={item.name} className="col-md-3 col-sm-12">
                    <div className="factory-process-value">
                      <div className="factory-overview-item-label">
                        {t(item.name)}
                        <div className="factory-overview-item-target-label">
                          {t("LT_target")}:{" "}
                          {item.target === "" ? "N/A" : item.target}
                          {item.unit}
                        </div>
                      </div>
                      <div
                        className="col-5 factory-overview-item-right fs30"
                        style={{ color: statusColor }}
                      >
                        {processValue}%
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  };

  const GenerateChart = (item) => {
    if (item.value === null) {
      item.value = 0;
    }
    let processValue = parseFloat(item.value.toFixed(1));
    let processColor = ValidateColor(processValue);

    let chartData = [
      ["Task", item.name],
      [item.name, processValue],
      ["", 100 - processValue],
    ];

    let options = {
      pieHole: 0.6,
      is3D: false,
      hAxis: { textPosition: "none" },
      timeline: { showBarLabels: false },
      colors: [processColor, "#F3F5F9"],
      legend: { position: "none" },
      labels: false,
      isStacked: "relative",
    };

    return (
      <div style={{marginTop:'20px'}}>
        <CustomDonutChart series={[item.value]} 
          labels={[item.name]} legendPosition="bottom" showLegend={false}
           tooltipDisabled={true} fillColors = {[processColor]} title={processValue+"%"}/>
        {/* <Chart
          chartType="PieChart"
          width="150px"
          height="150px"
          data={chartData}
          options={options}
        />
        <div
          className="col-5 factory-overview-item-right line-legend"
          style={{ marginLeft: processValue < 50 ? "5px" : 0 }}
        >
          {processValue}%
        </div> */}
      </div>
    );
  };

  const GenerateLineData = (data) => {
    return data?.map((item, index) => {
      return (
        <div
          key={item.name}
          className="factory-overview-wrapper bottom-adjustment"
          onClick={(event) => {
            getLineData(item.lineId);
          }}
        >
          <div className="factory-overview-header">{item.name}</div>
          <div className="factory-overview-body">
            <div className="row factory-overview-body-indent">
              {item.statistics &&
                item.statistics.map((item, index) => {
                  return (
                    <div key={item.name} className="col-md-3 col-sm-12">
                      <div className="factory-process-value">
                        <div className="factory-overview-item-label">
                          {t(item.name)}
                          <div className="factory-overview-item-target-label">
                            {t("LT_target")}:{" "}
                            {item.target === "" ? "N/A" : item.target}
                            {item.unit}
                          </div>
                        </div>
                        <div className="col-5 factory-overview-item-right chart-area">
                          {GenerateChart(item)}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="factory-overview">
      {GenerateStatisticsData(data)}
      {GenerateLineData(data.lines)}
    </div>
  );
};

export default FactoryLine;
